import styled from "styled-components";

export { Container, Main } from "../../../styles/adminPage";

export const Fieldset = styled.fieldset`
  border: none;
  padding: 0;
  margin-bottom: 2.4rem;
`;
